// Maps notification.type to a css class that is used to get the correct
// icon for the notification

export const NotificationIconMap = {
  'bank.connection.expired': `banking_consent-expired`,
  'delivery.creditnote.email.failure.email': `delivery_creditnote_email_failure_email`,
  'delivery.creditnote.email.sent': `delivery_creditnote_email_sent`,
  'delivery.estimate.email.sent': `delivery_estimate_email_sent`,
  'delivery.invoice.email.sent': `delivery_invoice_email_sent`,
  'delivery.receipt.email.failure.email': `delivery_receipt_email_failure_email`,
  'delivery.receipt.email.sent': `delivery_receipt_email_sent`,
  'delivery.recipient-portal.opened': `delivery_recipient-portal_opened`,
  'document.accepted': `document_accepted`,
  'document.rejected': `document_rejected`,
  'document.reminder.email.sent': `document_reminder_email_sent`,
  'document.reminder.email.notsent': `document_reminder_email_sent`,
  'email.estimate.delivery.fail': `email_estimate_delivery_fail`,
  'email.invoice.delivery.fail': `email_invoice_delivery_fail`,
  'invoice.paid': `invoice_paid`,
  'invoice.paynow.paid': `invoice_paynow_paid`,
  'invoice.tink.paid': `invoice_tink_paid`,
  'recurringscheduler.created.sent': `recurringscheduler_created_sent`,
  'recurringscheduler.send.fail': `.recurringscheduler_send_fail`,
  'subscription.expired': `subscription_expired`,
  'subscription.payment.failed': `subscription_payment_failed`,
  'subscription.resubscription.was.paid': `subscription_resubscription_was_paid`,
  'subscription.initial.was.paid': `subscription_initial_was_paid`,
  'subscription.will.expire': `subscription_will_expire`,
}
